<template>
  <div class="trajectory-data-table">
    <el-table
      v-loading="loading"
      :data="trajectoryData"
      stripe
      style="width: 100%; margin-top: 10px;"
      max-height="340"
      :header-cell-style="tableHeaderStyle"
      size="mini"
    >
      <el-table-column prop="timestamp" label="时间" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ formatTime(scope.row.timestamp) }}
        </template>
      </el-table-column>
      <el-table-column label="位置" min-width="120" align="center">
        <template slot-scope="scope">
          {{ formatCoordinate(scope.row.latitude) }}, {{ formatCoordinate(scope.row.longitude) }}
        </template>
      </el-table-column>
      <el-table-column label="速度" width="70" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="`${scope.row.speed === null ? '无速度数据' : scope.row.speed + ' 节'}`" placement="top" :open-delay="300">
            <span class="info-value">
              <i class="el-icon-speedometer"></i> {{ scope.row.speed === null ? '-' : scope.row.speed }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="航向" width="70" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="`航向: ${formatHeading(scope.row.heading)}°`" placement="top" :open-delay="300">
            <span class="info-value">
              <i class="el-icon-position"></i> {{ formatHeading(scope.row.heading) === '无' ? '-' : formatHeading(scope.row.heading) }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="60" align="center">
        <template slot-scope="scope">
          <el-tag 
            :type="scope.row.isWarning ? 'danger' : 'success'" 
            size="mini"
            :effect="scope.row.isWarning ? 'dark' : 'plain'"
          >
            {{ scope.row.isWarning ? '预警' : '正常' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    
    <div class="pagination-container">
      <el-pagination
        v-if="totalCount > 0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
        small>
      </el-pagination>
    </div>
    
    <div v-if="!trajectoryData.length && !loading" class="empty-data">
      <i class="el-icon-map-location"></i>
      <p>暂无航迹数据</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrajectoryDataTable',
  props: {
    trajectoryData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      tableHeaderStyle: {
        backgroundColor: '#f5f7fa',
        color: '#606266',
        fontWeight: '500',
        fontSize: '12px',
        padding: '5px 0'
      }
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit('pagination-change', { pageNum: page, pageSize: this.pageSize });
    },
    
    handleSizeChange(size) {
      this.$emit('pagination-change', { pageNum: 1, pageSize: size });
    },
    
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return this.formatDateTime(date);
    },
    
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      
      // 简化显示，不显示秒
      return `${month}-${day} ${hour}:${minute}:${second}`;
    },
    
    // 格式化坐标显示，最多显示4位小数
    formatCoordinate(value) {
      if (value === null || value === undefined) return '无';
      return Number(value).toFixed(4);
    },
    
    // 格式化航向或船首向，大于等于360显示为"无"
    formatHeading(angle) {
      if (angle === null || angle === undefined || angle >= 360) return '无';
      return angle;
    }
  }
}
</script>

<style scoped>
.trajectory-data-table {
  width: 100%;
  height: 100%;
}

.pagination-container {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  padding: 5px 0;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  color: #909399;
}

.empty-data i {
  font-size: 36px;
  margin-bottom: 10px;
  color: #dcdfe6;
}

.navigation-info {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.info-item {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  margin: 0 3px;
  white-space: nowrap;
}

.info-item i {
  margin-right: 3px;
  font-size: 14px;
}

.info-value {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  white-space: nowrap;
}

.info-value i {
  margin-right: 3px;
  font-size: 14px;
  color: #409EFF;
}

/* 自定义表格行样式 */
::v-deep .el-table__row {
  font-size: 12px;
}

::v-deep .el-table--mini td {
  padding: 3px 0;
}
</style> 